
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SopArea {
  id: string;
  name: string;
  brand_id: string;
  created_at: string;
  updated_at: string;
}

export const useSopAreas = (brandId: string) => {
  return useQuery({
    queryKey: ["sop-areas", brandId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("sop_areas")
        .select("*")
        .eq("brand_id", brandId);

      if (error) throw error;
      return data as SopArea[];
    },
    enabled: !!brandId,
  });
};
